import { Component } from '@angular/core';
import { LoadingServiceService } from './services/loading/loading-service.service';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
import { NavController, Platform } from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { ToastComponent } from './shared/toast/toast.component';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { LottieSplashScreen } from '@ionic-native/lottie-splash-screen/ngx';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';

import { CrudServiceService } from './services/crud/crud-service.service';
import { environment } from 'src/environments/environment';
import { SocketService } from './services/socket/socket.service';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  lottieConfig: any;
  anim: any;
  loadingFlag:boolean = false;
  userData : any;
  subscription : any;
  counter = 0;

  constructor(public loader : LoadingServiceService ,
    private platform: Platform,
    // private splashScreen: SplashScreen ,
    private statusBar: StatusBar,
    private fcm: FCM,
    private toast : ToastComponent,
    private lottieSplashScreen: LottieSplashScreen,
    private crudService : CrudServiceService,
    private navCtrl : NavController,
    public SocketService : SocketService,
    private backgroundMode : BackgroundMode
    ) {
      this.backgroundMode.enable();
      this.userData = JSON.parse(localStorage.getItem("userProfile"));
      if(this.userData){
        this.updateUser();
        this.SocketService.connectWithSocket(this.userData._id)
      }
this.initializeApp()
    setTimeout(() => {
      this.loadingFlag = true;
    }, 2000);
    this.lottieConfig = {
      path: 'assets/loading2.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true
  };



  }



  animationCreated(anim: any) {
    this.anim = anim;
}

initializeApp() {
  this.platform.resume.subscribe(() => {
    console.log("socket resumed again");

    this.userData = JSON.parse(localStorage.getItem("userProfile"));
    this.SocketService.unsubscribeSocket();
      if(this.userData){
        this.updateUser();
        this.SocketService.connectWithSocket(this.userData._id)
      }
      });
  this.platform.ready().then(() => {
    setTimeout(() => {
      this.lottieSplashScreen.hide();
        
      }, 5000);
    this.statusBar.overlaysWebView(false);
    this.statusBar.backgroundColorByHexString("#000000");

    if (this.platform.is('cordova')) {
      this.fcm.onNotification().subscribe((data) => {
        console.log(data,"notification");
        // if(data.consultingId){
        //   this.crudService.getDedtail(data.consultingId , environment.api.remoteConsulting).then((res:any)=>{
        //     console.log(res);
        //     this.SocketService.newVetConsultData = res;
        //     this.SocketService.newVetConsult = true;
        //     this.toast.presentToast("detected asjdbaskd jas das d")
        //     this.SocketService.playAudio();

        //   })
        // }
        if (data.wasTapped) {
          console.log(JSON.parse(JSON.stringify(data)));

          console.log("in background", JSON.stringify(data));
          if(data.route){
            if(data.appointmentDogId){
              this.navCtrl.navigateForward(data.route + data.appointmentDogId )
            }
          }
        } else {
          this.toast.presentToast(data.body)
        }
      })
    }
  });
}

updateUser(){
  this.crudService.getDedtail(this.userData._id , environment.api.businessUser).then((res)=>{
    localStorage.setItem("userProfile" , JSON.stringify(res))
  })
}

accept(){
  this.SocketService.newVetConsult = false;
this.SocketService.stopAudio();
this.SocketService.goToConsultlinig();
// this.navCtrl.navigateForward("/remote-consulting")
}
reject(){
  let userData = JSON.parse(localStorage.getItem("userProfile"));
  this.SocketService.newVetConsult = false;
  this.SocketService.stopAudio();
  this.SocketService.cancelConsulting();

}







}
